import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaLinkedinIn
} from "react-icons/fa";


import logo from "../Images/logo.png";
import { products } from "../Data";

const Header = () => {

  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const closeMobileMenu = () => {
  setMenuOpen(false);
  setMobileProductsOpen(false);
};

  return (
    <>
      <motion.header
        className="main-header"
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1],
        }}
      >

        <div className="header-container">

          {/* LOGO */}

          <a href="/">
            <motion.div
              className="logo-wrapper"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{
                delay: 0.2,
                duration: 0.6,
              }}
              whileHover={{ scale: 1.05 }}
            >
              <img
                src={logo}
                alt="Gurukrupa Wood Pvt. Ltd. Logo"
                className="logo-img"
              />
            </motion.div>
          </a>

          {/* NAVIGATION */}

          <motion.nav
            className="nav-links"
            initial="hidden"
            animate="visible"
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.12,
                  delayChildren: 0.3,
                },
              },
            }}
          >

            {/* NORMAL LINKS */}

            {[
              { name: "Home", link: "/" },
              { name: "About us", link: "/about-us" },
              { name: "Services", link: "/services" },
              { name: "Blog", link: "/blog" },
            ].map((item, index) => (
              <motion.a
                key={index}
                href={item.link}
                variants={{
                  hidden: { y: -20, opacity: 0 },
                  visible: { y: 0, opacity: 1 },
                }}
                transition={{ duration: 0.5 }}
                whileHover={{
                  y: -2,
                  transition: { duration: 0.2 },
                }}
              >
                {item.name}
              </motion.a>
            ))}

            {/* PRODUCTS DROPDOWN */}

            <motion.div
              className="products-dropdown"
              variants={{
                hidden: { y: -20, opacity: 0 },
                visible: { y: 0, opacity: 1 },
              }}
              transition={{ duration: 0.5 }}
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >

              <Link
  to="/products"
  className="dropdown-trigger"
  onClick={() => setShowDropdown(false)}
>
  <span>Products</span>

  <motion.div
    animate={{
      rotate: showDropdown ? 180 : 0,
    }}
    transition={{ duration: 0.25 }}
  >
    <FaChevronDown />
  </motion.div>
</Link>
              <AnimatePresence>

                {showDropdown && (

                  <motion.div
                    className="dropdown-menu"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.25 }}
                  >

                    {products.map((item, i) => (

                      <a
                        href={`/products/${item.slug}`}
                        key={i}
                        className="dropdown-item"
                      >
                        {item.title}
                      </a>

                    ))}
                    <a href="/products/customised-packaging" className="dropdown-item">Customised Packaging</a>

                  </motion.div>

                )}

              </AnimatePresence>

            </motion.div>

          </motion.nav>

          {/* BUTTON */}

          <motion.a
            href="/contact-us"
            className="green-btn"
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{
              delay: 0.7,
              duration: 0.6,
            }}
            whileHover={{
              scale: 1.05,
            }}
            whileTap={{ scale: 0.96 }}
          >
            Contact Us
          </motion.a>

        </div>

        {/* MOBILE HEADER */}


      </motion.header>
      <div className="mobile-header">

  {/* LOGO */}

  <a href="/">
    <img
      src={logo}
      alt="Gurukrupa Wood Pvt. Ltd. Logo"
      className="mobile-logo"
    />
  </a>

  {/* HAMBURGER */}

  <button
    className={`hamburger ${menuOpen ? "active" : ""}`}
    onClick={() => setMenuOpen(!menuOpen)}
  >
    <span></span>
    <span></span>
    <span></span>
  </button>

</div>

{/* MOBILE SIDEBAR */}

<motion.div
  className={`mobile-sidebar ${menuOpen ? "active" : ""}`}
  initial={false}
  animate={{
    x: menuOpen ? 0 : "-100%",
  }}
  transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1],
  }}
>

  {/* TOP */}

  <div className="sidebar-top">

    <img
      src={logo}
      alt="Gurukrupa Wood Pvt. Ltd. Logo"
      className="sidebar-logo"
    />

  </div>

  {/* NAV LINKS */}

  {/* NAV LINKS */}

<div className="sidebar-links">

  <a href="/">Home</a>

  <a href="/about-us">
    About us
  </a>

  {/* PRODUCTS DROPDOWN */}

<div className="mobile-products-dropdown">

  <div
    className={`mobile-dropdown-trigger ${
      mobileProductsOpen ? "active" : ""
    }`}
  >

    {/* PRODUCTS PAGE */}
    <Link
      to="/products"
      className="mobile-products-link"
      onClick={closeMobileMenu}
    >
      Products
    </Link>

    {/* DROPDOWN ARROW */}
    <button
      type="button"
      className="mobile-products-arrow"
      onClick={() =>
        setMobileProductsOpen((prev) => !prev)
      }
    >
      <motion.div
        animate={{
          rotate: mobileProductsOpen ? 180 : 0,
        }}
        transition={{
          duration: 0.25,
        }}
      >
        <FaChevronDown />
      </motion.div>
    </button>

  </div>

  <AnimatePresence>

    {mobileProductsOpen && (

      <motion.div
        className="mobile-dropdown-menu"
        initial={{
          height: 0,
          opacity: 0,
        }}
        animate={{
          height: "auto",
          opacity: 1,
        }}
        exit={{
          height: 0,
          opacity: 0,
        }}
        transition={{
          duration: 0.3,
        }}
      >

        {products.map((item, i) => (

          <Link
            to={`/products/${item.slug}`}
            key={i}
            className="mobile-dropdown-item"
            onClick={closeMobileMenu}
          >
            {item.title}
          </Link>

        ))}

        <Link
          to="/products/customised-packaging"
          className="mobile-dropdown-item"
          onClick={closeMobileMenu}
        >
          Customised Packaging
        </Link>

      </motion.div>

    )}

  </AnimatePresence>

</div>

  <a href="/services">
    Services
  </a>

   <a href="/blog">
    Blog
  </a>

  <a href="/contact-us">
    Contact Us
  </a>

</div>
  {/* FOOTER */}

  <div className="sidebar-footer">

    <div className="sidebar-contact-item">
      <FaPhoneAlt />
      <a href="tel:+919624065081">
        +91 96240 65081
      </a>
    </div>

    <div className="sidebar-contact-item">
      <FaEnvelope />
      <a href="mailto:jignesh@gurukrupawood.com">
        jignesh@gurukrupawood.com
      </a>
    </div>
  <motion.div
  className="footer-socials mobile-socials"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{
    delay: 0.35,
    duration: 0.6,
  }}
  viewport={{ once: true }}
>

  {/* FACEBOOK */}

  <motion.a
    href="https://www.facebook.com/profile.php?id=61589890865706"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -4,
      scale: 1.08,
    }}
    whileTap={{ scale: 0.95 }}
  >
    <FaFacebookF />
  </motion.a>

  {/* LINKEDIN */}

  <motion.a
    href="https://www.linkedin.com/company/gurukrupa-wood-pvt-ltd/"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -4,
      scale: 1.08,
    }}
    whileTap={{ scale: 0.95 }}
  >
    <FaLinkedinIn />
  </motion.a>

</motion.div>
  </div>

</motion.div>

{/* OVERLAY */}

{menuOpen && (
  <div
    className="sidebar-overlay"
    onClick={() => setMenuOpen(false)}
  ></div>
)}

    </>
  );
};

export default Header;